const CheckboxIcon = (props: any) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00065 14.6667H10.0007C13.334 14.6667 14.6673 13.3334 14.6673 10V6.00004C14.6673 2.66671 13.334 1.33337 10.0007 1.33337H6.00065C2.66732 1.33337 1.33398 2.66671 1.33398 6.00004V10C1.33398 13.3334 2.66732 14.6667 6.00065 14.6667Z"
        stroke={props.color || "#090A1D"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { CheckboxIcon };
